
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";
import NoticeLawyerParty from "./NoticeLawyerParty.vue";
import ReviewYourAnswersNlp from "./reviewNLP/ReviewYourAnswersNLP.vue";
import PreviewFormsNlp from "./reviewNLP/PreviewFormsNLP.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        NoticeLawyerParty,
        ReviewYourAnswersNlp,
        PreviewFormsNlp        
    }
})
export default class LawyerPartyStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
